import axios from 'axios';

const apiClient = axios.create({
    // baseURL: 'https://nsar-webapi.azurewebsites.net',
    baseURL: 'https://nsar-webapi-dev.azurewebsites.net',
    // baseURL: 'https://localhost:44336', // .NET webapi local
    withCredentials: false, // This is the default
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

export default {
    getLockboxData(startDate: string, endDate: string) {
        return apiClient.get('/lockbox/csv?startDate=' + startDate + '&endDate=' + endDate);
    },
    getDateCount(startDate: string, endDate: string) {
        return apiClient.get('/lockbox/datecount?startDate=' + startDate + '&endDate=' + endDate);
    },
};
